import { StyleSheet, View } from 'react-native';
import { Bot, Target } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import type { AiDiagnosisViewModel } from '../../types/learningAnalysis';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type AiDiagnosisCardProps = {
  diagnosis: AiDiagnosisViewModel;
};

export function AiDiagnosisCard({ diagnosis }: AiDiagnosisCardProps) {
  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <View style={styles.iconWrap}>
          <Bot size={18} color={tokens.colors.primary} />
        </View>
        <View style={styles.copy}>
          <AppText variant="body" weight="bold">
            AI 诊断
          </AppText>
          <AppText variant="caption" tone="muted">
            {diagnosis.title}
          </AppText>
        </View>
      </View>

      <AppText variant="body">{diagnosis.summary}</AppText>

      <View style={styles.section}>
        <AppText variant="caption" tone="danger" weight="bold">
          错因分析
        </AppText>
        {diagnosis.errorCauses.map((cause) => (
          <AppText key={cause} variant="caption" tone="muted">
            · {cause}
          </AppText>
        ))}
      </View>

      <View style={styles.section}>
        <View style={styles.attackTitle}>
          <Target size={16} color={tokens.colors.warning} />
          <AppText variant="caption" tone="warning" weight="bold">
            薄弱点攻坚
          </AppText>
        </View>
        {diagnosis.attackPlans.map((plan) => (
          <AppText key={plan} variant="caption">
            · {plan}
          </AppText>
        ))}
      </View>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
  },
  iconWrap: {
    width: 36,
    height: 36,
    borderRadius: tokens.radius.full,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  copy: {
    flex: 1,
    gap: 2,
  },
  section: {
    gap: tokens.spacing.xs,
    borderRadius: tokens.radius.md,
    padding: tokens.spacing.md,
    backgroundColor: tokens.colors.background,
  },
  attackTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.xs,
  },
});
